import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SavedSearch } from './saved-search.dto';

@Injectable()
export abstract class ObservableSavedSearchService {
  abstract list(divisionId: string): Observable<SavedSearch[]>;
  abstract get(divisionId: string, id: string): Observable<SavedSearch>;
}
